import { render, staticRenderFns } from "./LocationBasic.vue?vue&type=template&id=b4a28532&"
import script from "./LocationBasic.vue?vue&type=script&lang=js&"
export * from "./LocationBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports